export function umtrack(type, query, vue){
   console.log(type, query)
   switch (type) {
       case 'itemClick':
           // 首页内容点击
           vue.$uweb.trackEvent("block", 'block-item-click', query.title, query.id)
           break;
        case 'mainView':
            // 首页浏览
            vue.$uweb.trackPageview("discover-view")
            break;
        case 'albumView':
            // 专辑详情页
            vue.$uweb.trackPageview("alibum-view")
            break;
        case 'blockView':
            // 块信息浏览
            vue.$uweb.trackPageview("block-view")
            break;
        case 'tryPlay':
            // 试看点击
            vue.$uweb.trackEvent("试看", 'trysee-click', query.title, query.id)
            break;
        case 'noPay':
            // 没有支付点击播放
            vue.$uweb.trackEvent("未支付点击播放", 'nopay-click', query.title, query.id)
            break;
        case 'play':
            // 播放点击
            vue.$uweb.trackEvent("播放", 'play-click', query.title, query.id)
            break;
        case 'pay':
            // 发起支付点击
            vue.$uweb.trackEvent("支付", 'pay-click', query.title, query.id)
            break;
        case 'vipview':
            // vip页面显示
            vue.$uweb.trackEvent("vip页面", 'vip-view', query.title, query.code)
            break;
        case 'vip-pay':
            // vip支付
            vue.$uweb.trackEvent("vip支付", 'vip-pay', query.title, query.id)
            break;
        case 'vip-pupo':
            // vip支付
            vue.$uweb.trackEvent("vip弹窗", 'vip-pupo', '', '')
            break;
        case 'couponview':
            // vip页面显示
            vue.$uweb.trackEvent("优惠劵页面", 'coupon-view', query.title, query.code)
            break;
        case 'coupon-pay':
            // vip支付
            vue.$uweb.trackEvent("优惠劵支付", 'coupon-pay', query.title, query.id)
            break;
       default:
           break;
   }
}